import { render, staticRenderFns } from "./MessageAttachment.vue?vue&type=template&id=4299c7e6&scoped=true&"
var script = {}
import style0 from "./MessageAttachment.vue?vue&type=style&index=0&id=4299c7e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4299c7e6",
  null
  
)

export default component.exports